<ng-container>
  <section class="header">
    <img src="/assets/icons/svg-imports/landing-create.svg" alt="" aria-hidden="true">
    <h1>{{header}}</h1>
    @if (description) {
      <p>{{description}}</p>
    }
  </section>
  <section class="content">
    @for (data of options; track data) {
      <button class="importer-item" (click)="showSelected(data)" tabindex="0" [attr.aria-label]="data.display_value">
        <img width="42"	src="{{data.icon}}" alt="{{data.display_value + ' icon'}}">
        <section class="title">
          <h2>{{data.display_value}}</h2>
          <p>{{data.description}}</p>
        </section>
      </button>
    }
  </section>
</ng-container>